// Shared brand tokens for Plotly charts.
// Must be explicit hex/rgba — Plotly renders to SVG and ignores CSS currentColor.
export const BRAND = {
  cloud:       '#f0efef',
  charcoal:    '#242120',
  ink:         '#161514',
  inkMuted:    '#5f5a59',
  onDark:      'rgba(255,255,255,0.82)',
  onDarkMuted: 'rgba(255,255,255,0.62)',
  steel:       '#d8d6d6',
  lineOnDark:  'rgba(255,255,255,0.08)',
  gridLight:   '#e8e7e7',
  gridDark:    'rgba(255,255,255,0.06)',
  red:         '#cd2127',
  fontDisplay: 'Saira, Arial Narrow, Arial, sans-serif',
  fontBody:    'Poppins, Inter, sans-serif',
};

/**
 * Returns Plotly layout overrides for the current color scheme.
 * Merge this into your layout object so every Plotly property uses brand tokens.
 *
 * @param {boolean} dark - true when dark mode is active
 */
export function getThemeLayout(dark) {
  const fontColor  = dark ? BRAND.onDark      : BRAND.ink;
  const mutedColor = dark ? BRAND.onDarkMuted : BRAND.inkMuted;
  const borderColor = dark ? BRAND.lineOnDark  : BRAND.steel;
  const gridColor  = dark ? BRAND.gridDark    : BRAND.gridLight;
  const surfaceBg  = dark ? BRAND.charcoal    : BRAND.cloud;

  return {
    paper_bgcolor: 'transparent',
    plot_bgcolor:  'transparent',
    font: {
      color:  fontColor,
      family: BRAND.fontBody,
    },
    xaxis: {
      linecolor:     borderColor,
      gridcolor:     gridColor,
      tickcolor:     mutedColor,
      tickfont:      { color: mutedColor, family: BRAND.fontBody },
      zerolinecolor: borderColor,
      rangeslider: {
        bgcolor:     surfaceBg,
        bordercolor: borderColor,
      },
      rangeselector: {
        bgcolor:     surfaceBg,
        bordercolor: borderColor,
        borderwidth: 1,
        activecolor: dark ? 'rgba(205,33,39,0.3)' : 'rgba(205,33,39,0.12)',
        font:        { color: fontColor, family: BRAND.fontBody },
      },
    },
    yaxis: {
      linecolor:     borderColor,
      gridcolor:     gridColor,
      tickcolor:     mutedColor,
      tickfont:      { color: mutedColor, family: BRAND.fontBody },
      zerolinecolor: borderColor,
    },
    legend: {
      bgcolor:     dark ? 'rgba(36,33,32,0.85)' : 'rgba(240,239,239,0.85)',
      bordercolor: borderColor,
      borderwidth: 1,
      font:        { color: fontColor, family: BRAND.fontBody },
    },
  };
}
